import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10, TablesWidget5 } from "../../../smallnation/partials/widgets"

import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";

import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useNavigate, useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import UsNumberValidate from "../../modules/utility/usNumberValidate"

const CreateJobseeker: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducation] = useState([]);
  const red = "red";
  const [itemName, setFieldName] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [personalProfiles, setPersonalProfile] = useState([]);
  const [educationInformation, setEducationInfo] = useState([]);
  const [trainingInformation, setTrainingInfo] = useState([]);
  const [seekingPositionfor, setSeekingPosition] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [collegeInfo, setCollegeInfo] = useState([]);

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {
    const checked = $('input[name="categoryexp"]:checked').length;

    if (checked >= 3) {
      $('input[name="categoryexp"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="categoryexp"]').prop('disabled', false);
    }
  }
  function getImage() {
    var files = document.getElementById('resume').files;

    console.log(files);
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];
      // alert(fileActName);
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "doc" && fextn != "docx" && fextn != "pdf") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
      }

    }
  }

  function handleChangePersonalProfileDesc(content) {
    setPersonalProfile(content);
  }

  function handleChangeTrainingInfoDesc(content) {
    setTrainingInfo(content);
  }

  function handleChangeSeekingPositionDesc(content) {
    setSeekingPosition(content);
  }

  //function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
  function handleImageUploadBefore(files, info, uploadHandler) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var base64result = reader.result.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const submitValue = () => {


    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var password_regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    var passwordConf = $("#conf_password").val();
    var passwordCheck = $("#password").val();
    //alert('submit');
    var categoriesArray = [];

    $.each($("input[name='categoryexp']:checked"), function () {
      categoriesArray.push($(this).val());
    });
    var validateEditorTxt = 1;
    if ($('#first_name').val() == "") {
      $("#firstNameValidMsg").show();
      $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#firstNameValidMsg").hide();
    }

    if ($('#last_name').val() == "") {
      $("#lastNameValidMsg").show();
      $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#lastNameValidMsg").hide();
    }
    var email = $('#email_id').val();
    if (email == "") {
      $("#emailReqMsg").show();
      $(window).scrollTop($('#emailReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailReqMsg").hide();
    }

    if (email != "" && email_regex.test(email) == false) {
      $("#emailValidMsg").show();
      $(window).scrollTop($('#emailValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailValidMsg").hide();
    }

    if ($('#phone_number').val() == "") {
      $("#phoneValidMsg").show();
      $(window).scrollTop($('#phoneValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#phoneValidMsg").hide();
    }

    if (passwordCheck == "") {
      $("#passwordReqMsg").show();
      $(window).scrollTop($('#passwordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordReqMsg").hide();
    }

    if (passwordCheck != "" && password_regex.test(passwordCheck) == false) {
      $("#passwordValidMsg").show();
      $(window).scrollTop($('#passwordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordValidMsg").hide();
    }

    if (passwordConf == "") {
      $("#confpasswordReqMsg").show();
      $(window).scrollTop($('#confpasswordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordReqMsg").hide();
    }

    if (passwordConf != "" && password_regex.test(passwordConf) == false) {
      $("#confpasswordValidMsg").show();
      $(window).scrollTop($('#confpasswordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordValidMsg").hide();
    }

    if (passwordConf != passwordCheck) {
      $("#matchValidMsg").show();
      $(window).scrollTop($('#matchValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#matchValidMsg").hide();
    }

    if ($('#educationId').val() == "") {
      $("#educationValidMsg").show();
      $(window).scrollTop($('#educationValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#educationValidMsg").hide();
      if ($('#educationId').val() == 3) {
        if ($('#schoolId').val() == '') {
          $("#schoolValidMsg").show();
          $(window).scrollTop($('#schoolValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#schoolValidMsg").hide();
        }

        if ($('#schoolId').val() == 0 && $('#schoolIdOther').val() == '') {
          $("#schoolIdOtherValidMsg").show();
          $(window).scrollTop($('#schoolIdOtherValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#schoolIdOtherValidMsg").hide();
        }

      }
      else {
        console.log('here');
        if ($('#university_name').val() == '') {
          $("#university_nameValidMsg").show();
          $(window).scrollTop($('#university_nameValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#university_nameValidMsg").hide();
        }

        if ($('#university_name').val() == 22 && $('#collegeIdOther').val() == '') {
          $("#collegeIdOtherValidMsg").show();
          $(window).scrollTop($('#collegeIdOtherValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#collegeIdOtherValidMsg").hide();
        }
      }
    }

    if ($('#schoolId').val() == "" && $('#educationId').val() == '3') {
      $("#schoolValidMsg").show();
      $(window).scrollTop($('#schoolValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#schoolValidMsg").hide();
    }

    var selectedEduction = $("#continueEducationSelect").val();
    if(selectedEduction == '' || selectedEduction == null){
      $("#continuingEducationValidMsg").show();
      $(window).scrollTop($('#continuingEducationValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $('#continuingEducationValidMsg').hide();
      if ($("#continueEducationSelect").val() == 'Y') {
        if ($('#collegeId').val() == "") {
          $("#collegeValidMsg").show();
          $(window).scrollTop($('#collegeValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#collegeValidMsg").hide();
        }
  
        if ($('#pursuingProgram').val() == "") {
          $("#pursuingProgramValidMsg").show();
          $(window).scrollTop($('#pursuingProgramValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#pursuingProgramValidMsg").hide();
        }
      }
    }
    

    if ($('#jobType').val() == "") {
      $("#jobtypeValidMsg").show();
      $(window).scrollTop($('#jobtypeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#jobtypeValidMsg").hide();
    }

    if (fileExtension == "") {
      $("#fileReqMsg").show();
      $(window).scrollTop($('#fileReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#fileReqMsg").hide();
    }

    if ((fileExtension != "") && (fileExtension != "doc" && fileExtension != "docx" && fileExtension != "pdf")) {
      //document.getElementById('logo').reset();
      $("#fileError").show();
      $(window).scrollTop($('#fileError').position().top);
      validateEditorTxt = 0;
    } else {
      $("#fileError").hide();
    }

    if (categoriesArray.length <= 1) {
      $("#categoryValidMsg").show();
      $(window).scrollTop($('#categoryValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }

    if (personalProfiles == "") {
      $("#personalProfileValidMsg").show();
      $(window).scrollTop($('#personalProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#personalProfileValidMsg").hide();
    }

    /*
    if(educationInformation == ""){
      $("#educationInfoValidMsg").show();  
     //$(window).scrollTop($('#educationInfoValidMsg').position().top);
      validateEditorTxt = 0;     
    }else{
      $("#educationInfoValidMsg").hide();  
    } 
    */

    if (trainingInformation == "") {
      $("#trainingInfoValidMsg").show();
      //$(window).scrollTop($('#trainingInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#trainingInfoValidMsg").hide();
    }


    if (seekingPositionfor == "") {
      $("#seekingPositionValidMsg").show();
      //$(window).scrollTop($('#seekingPositionValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#seekingPositionValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }


    var selectedEduction = $("#continueEducationSelect").val();
    var eduId = $("#educationId").val();
    const requestObject = {
      "siteId": 2,
      "countyId": 2,
      "firstName": $('#first_name').val(),
      "lastName": $('#last_name').val(),
      "email": $('#email_id').val(),
      "phone": $('#phone_number').val(),
      "password": $('#password').val(),
      "personalProfile": personalProfiles,
      //"educationExperiance":educationInformation,
      "certificationTraining": trainingInformation,
      "jobType": $('#jobType').val(),
      "enrolledCollege": $('#collegeId').val(),
      "pursuingProgram": $("#pursuingProgram")
        .val(),
      "levelEducation": $("#educationId").val(),
      "listSchool": $("#schoolId").val(),
      "continueEducation": selectedEduction,
      "listSchoolOther": $('#schoolIdOther').val(),
      "listCollegeId": $('#university_name').val(),
      "listCollegeOther": $('#collegeIdOther').val(),
      "schoolIdOther": $("#schoolIdOther").val(),
      "lookingFor": seekingPositionfor,
      "resumePath": $("#resumePath").val(),
      "status": "published",
      "categoriesOfExpertise": categoriesArray,
      "pdfByString": fileBase64,
      "fileName": fileName,
      "fileExtension": fileExtension
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminAddProfile(requestOptions).then((res) => {

      console.log(res);
      if (res.code == '200') {
        $("#addjobseekersuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addjobseekersuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/profiledirectory');
        }, 1000);

      }
      else {
        $("#addjobseekerfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addjobseekerfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });
  }

  const getEducation = () => {
    services.getEducation().then((res) => {
      console.log("getEducation data=" + JSON.stringify(res.data));
      setEducation(res.data.content);
    });
  }

  function handleChangeEducation(event) {
    //alert("teste")
    //alert(event.target.value);
    var sch = event.target.value;
    $("#schoolId").val('');
    if (sch == "3") {
      $("#schoolId").prop('disabled', false);
    } else {
      $("#schoolId").prop('disabled', true);
    }
  }
  function handleChangeSchool(event) {
    //alert("teste")
    //alert(event.target.value);
    var sch = event.target.value;
    $('#schoolIdOther').val('');
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (sch == "33") {
      $("#schoolIdOtherDiv").show();
    } else {
      $("#schoolIdOtherDiv").hide();
    }
  }

  $('#educationId').change(function () {
    $('#schoolValidMsg').hide();
    $('#university_nameValidMsg').hide();
    $('#university_name').val('');
    $('#schoolId').val('');
    $('#collegeIdOtherDiv').hide();
    $('#schoolIdOtherDiv').hide();
    if ($('#educationId').val() == 3) {
      $('#school_div').show();
      $('#college_div').hide();
      $('#schoolId').prop('disabled', false);
    }
    else {
      $('#school_div').hide();
      $('#college_div').show();
      $('#schoolId').prop('disabled', true);
    }
  })

  function handleChangeCollege(event) {
    //alert("teste")
    //alert(event.target.value);
    var clg = event.target.value;
    $('#collegeIdOther').val('');
    //console.log(event.target.value);
    //var sch = $("#schoolId'").val();    
    if (clg == "22") {
      $("#collegeIdOtherDiv").show();
    } else {
      $("#collegeIdOtherDiv").hide();
    }
  }

  function handleChangeContinueEdu(event) {

    var selectedEdu = $('#continueEducationSelect').val();
    //alert(selectedEdu);
    if (selectedEdu == "Y") {
      $("#continueEduDiv").show();
    } else if (selectedEdu == "N") {
      $("#continueEduDiv").hide();
    }

  }
  const getSchoolList = () => {
    //alert("14");
    const requestObject = {
      "siteId": 2,
      "pageNumber": "1",
      "pageSize": 150,
      "orderBy": "name"
    }

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getSchoolList(requestOptions).then((res) => {
      console.log("############36");
      console.log(JSON.stringify(res))
      if (res) {
        console.log(JSON.stringify(res.data));


        var contAr = res.content;
        //setProfileList(res.content);
        if (res) {
          setSchoolList(res);
        }


      }
      //navigate('/thankyou');

    });


  }
  const getCollegeInfo = () => {
    services.getEnrolledCollege().then((res) => {
      //console.log("getEducation data=" + JSON.stringify(res.data));
      setCollegeInfo(res.data);
    });
  }

  /*$( "#inlineRadio1, #inlineRadio2" ).click(function() {
    var selectedEdu = $('input[name="continueEducation"]:checked').val();
  // alert(selectedEdu);
  if( selectedEdu == "Y"){
    $("#continueEduDiv").show();
  }else  if( selectedEdu == "N"){
    $("#continueEduDiv").hide();
  }
  }); */

  useEffect(() => {
    //$("#schoolId").prop('disabled', true);
    $('#phone_number').usPhoneFormat();
    $(".se-dialog-tabs").hide();
    ($('#phone_number')).usPhoneFormat();
    $("#personalProfileValidMsg").hide();
    //$("#educationInfoValidMsg").hide();
    $("#trainingInfoValidMsg").hide();
    $("#seekingPositionValidMsg").hide();
    $("#firstNameValidMsg").hide();
    $("#lastNameValidMsg").hide();
    $("#emailValidMsg").hide();
    $("#phoneValidMsg").hide();
    $("#passwordValidMsg").hide();
    $("#matchValidMsg").hide();
    $("#confpasswordValidMsg").hide();
    $("#educationValidMsg").hide();
    $("#schoolValidMsg").hide();
    $("#categoryValidMsg").hide();
    $("#collegeValidMsg").hide();
    $("#pursuingProgramValidMsg").hide();
    $("#jobtypeValidMsg").hide();
    $('#emailReqMsg').hide();
    $('#passwordReqMsg').hide();
    $('#confpasswordReqMsg').hide();
    $('#fileReqMsg').hide();
    $("#addjobseekersuccessMessage").hide();
    $('#addjobseekerfailMessage').hide();
    $('#college_div').hide();
    $("#schoolIdOtherDiv").hide();
    $('#collegeIdOtherDiv').hide();
    $('#continuingEducationValidMsg').hide();
    //validateCheck();
    getEducation();
    getSchoolList();
    getCollegeInfo();
    $("#continueEduDiv").hide();
    services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    });
    services.getJobType().then((res) => {
      console.log("setJobType data=" + JSON.stringify(res.data));
      var tempjobtypes = res.data.content;

      var jobtypes_sorted = tempjobtypes.sort((a, b) => b.jobTypeId - a.jobTypeId);
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));

      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Job Shadow';
      });
      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Continuing Education';
      });
      setJobType(jobtypes_sorted);
    });
    $("#matchPwd").hide();
    $("#fileError").hide();
    $('#educationValidMsg').hide();
    $('#schoolValidMsg').hide();
    $('#university_nameValidMsg').hide();
    $('#university_nameValidMsg_m').hide();
    $('#schoolIdOtherValidMsg').hide();
    $('#collegeIdOtherValidMsg').hide();


    /* $( "#inlineRadio1, #inlineRadio2" ).click(function() {
       var selectedEdu = $('input[name="continueEducation"]:checked').val();
    // alert(selectedEdu);
     if( selectedEdu == "Y"){
       $("#continueEduDiv").show();
     }else  if( selectedEdu == "N"){
       $('#collegeId').val('');
       $('#pursuingProgram').val('');
       $("#continueEduDiv").hide();
     }
     }); */
    /*
    $( "#schoolId" ).change(function() {
      var sch = $("#schoolId'").val();
      alert(sch);
      if(sch == "0"){
        $("#schoolIdOtherDiv").show();
      }else{
        $("#schoolIdOtherDiv").hide();
      }
    });
    */
    $("#continuedegreeValidMsg").hide();
    $("#continueprogramValidMsg").hide();

    $("#schoolIdOtherDiv").hide();
    setTimeout(() => {
      // $('#educationId').val('3');
      $('input[id="inlineRadio2"]').prop('checked', true);
    }, 1000)
  }, []);

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
  return (
    <>
      <PageTitle breadcrumbs={[]}>Jobseeker Registration</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>

        {/* <h1>write your code here</h1> */}

        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">First Name </label>

                </div>
                <input id="first_name" name="first_name" type="text" className="form-control" placeholder="" />
                <div id="firstNameValidMsg" style={{ color: red }} className="error">First Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Last Name </label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" placeholder="" />
                <div id="lastNameValidMsg" style={{ color: red }} className="error">Last Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" placeholder="" />
                <div id="emailValidMsg" style={{ color: red }} className="error">Email must be valid.</div>

                <div id="emailReqMsg" style={{ color: red }} className="error">Email is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Phone</label>
                  <small className="mb-3">xxx-xxx-xxxx</small>
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" placeholder="" />
                <div id="phoneValidMsg" style={{ color: red }} className="error">Phone Number is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="password" name="password" className="form-control" placeholder="" />
                <div id="passwordReqMsg" style={{ color: red }} className="error">Password is reequired.</div>
                <div id="passwordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Confirm Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="conf_password" name="conf_password" className="form-control" placeholder="" />
                <div id="confpasswordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>

                <div id="confpasswordReqMsg" style={{ color: red }} className="error">Confirm Password is required.</div>

                <div id="matchValidMsg" style={{ color: red }} className="error">Confirm Password should match with Password.</div>

              </div>
            </div>
            <div className="col-lg-12 mb-10">
              <div className="mb-2 ">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Personal Profile</label>

                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="personalprofile"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setPersonalProfile(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangePersonalProfileDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="personalProfileValidMsg" style={{ color: red }} className="error">Personal Profile is required.</div>
                {/*  <textarea class="form-control textarea" maxlength="500" placeholder="Leave a comment here" id="personalProfile" onChange={e => setFieldName(e.target.value)}  {...register("personalinfo", {
                                    required: "Personal Profile is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="personalinfo"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                    ? Object.entries(messages).map(([type, message]) => (
                                        <p key={type}  class="error">{message}</p>
                                    ))
                                    : null;
                                }}
                                   
                                /> */}
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Level of Education Completed</label>
                </div>
                {/* onChange={handleChangeEducation}*/}
                <select class="form-select" aria-label="Default select example" id="educationId" name="educationId" >

                  <option selected value="">Select</option>
                  {
                    educations.map((data, index) => (
                      <option value={data.educationId}>{data.name}</option>
                    ))}
                </select>
                <div id="educationValidMsg" style={{ color: red }} className="error">Level of Education is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="school_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Graduated From</label>
                </div>
                <select class="form-select" aria-label="Default select example" id="schoolId" name="schoolId" onChange={handleChangeSchool} >
                  <option selected value="">Select</option>
                  {
                    schoolList.map((data, index) => (
                      <option value={data.schoolId}>{data.name}</option>
                    ))}
                 {/* <option value="0" >Other</option> */}
                </select>
                <div id="schoolValidMsg" style={{ color: red }} className="error">School is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="schoolIdOtherDiv">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Name of The Institution</label>
                </div>
                <input type="text" class="form-control " id="schoolIdOther" aria-describedby="emailHelp" placeholder="Other" />
                <div id="schoolIdOtherValidMsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="college_div">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">College / University</label>
                </div>
                <select class="form-select" id="university_name" onChange={handleChangeCollege}>
                  <option value="">Select College</option>
                  {
                    collegeInfo.map((data, index) => (
                      <option value={data.enrolledCollegeId}>{data.name}</option>
                    ))}
                </select>
                <div id="university_nameValidMsg" style={{ color: red }} className="error">College / Universities is required.</div>
              </div>
            </div>

            <div className="col-lg-6" id="collegeIdOtherDiv">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Name of The Institution</label>
                </div>
                <input type="text" class="form-control " id="collegeIdOther" aria-describedby="emailHelp" placeholder="Other" />
                <div id="collegeIdOtherValidMsg" style={{ color: red }} className="error">Name of the Institution is required.</div>
              </div>
            </div>



            <div className="col-lg-12">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Are you currently continuing education?</label>
                </div>
              </div>
              <div className="row px-0 mb-10">
                <select class="form-select" id="continueEducationSelect" name="continueEducationSelect" onChange={handleChangeContinueEdu} >
                  <option value="Y">Yes</option>
                  <option selected value="N">No</option>

                </select>
                <div id="continuingEducationValidMsg" style={{ color: red }} class="error">Are you currently continuing education is required.</div>
                {/*} <ul class="col-md-6 mb-4 d-flex">
                                 <li className='d-flex'><input class="form-check form-check-custom form-check-solid" type="radio" name="continueEducation" id="inlineRadio1"  onChange={handleChangeContinueEdu} value="Y" style={{borderRadius: "30px" }}/>
    <label class="form-check-label mx-2" htmlFor="inlineRadio1">YES</label></li> 
    <li className='d-flex mx-3'> <input class="form-check form-check-custom form-check-solid" type="radio" name="continueEducation" id="inlineRadio2" checked onChange={handleChangeContinueEdu} value="N"/>
    <label class="form-check-label mx-2" htmlFor="inlineRadio2">NO</label></li> 
                                 
                                  </ul>
                                 */}
              </div>

              <div className="row mb-10" id="continueEduDiv">




                <div className="col-lg-6">
                  <div>
                    <div className="d-flex flex-column ">
                      <label className="required form-label">Name of The Institution</label>

                    </div>
                    <select class="form-select" id="collegeId" name="collegeId" >
                      <option selected value=''>Select College</option>
                      {
                        collegeInfo.map((data, index) => (
                          <option value={data.enrolledCollegeId}>{data.name}</option>
                        ))}
                      <option value='Other'>Other</option>
                    </select>
                    <div id="collegeValidMsg" style={{ color: red }} className="error">Name of The Institution is Required.</div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div>
                    <div className="d-flex flex-column ">
                      <label className="required form-label">Pursuing Program</label>
                    </div>
                    <input type="text" class="form-control " id="pursuingProgram" name="pursuingProgram" aria-describedby="emailHelp" placeholder="pursuing" />

                    <div id="pursuingProgramValidMsg" style={{ color: red }} className="error">Pursuing Program is required.</div>
                  </div>
                </div>
              </div>
            </div>





            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Certification / Training</label>
                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="trainingInfo"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setTrainingInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeTrainingInfoDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="trainingInfoValidMsg" style={{ color: red }} className="error">Certification is required.</div>


                {/*<textarea class="form-control textarea"   maxlength="500"placeholder="Leave a comment here" id="certificationTraining" onChange={e => setFieldName(e.target.value)} {...register("certificate", {
                                    required: "Certification/training is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="certificate"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />  */}
              </div>
            </div>
            <div className="col-lg-12 mb-10">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Categories of EXPERTISE</label>
                </div>
              </div>
              <div className="row px-0">


                {
                  categories.map((data, index) => (

                    <div class="col-md-6 mb-4 form-check form-check-custom form-check-solid"><input class="form-check-input" type="checkbox" name="categoryexp" value={data.catId} id="defaultCheck1" />  <label class="form-check-label" htmlFor="defaultCheck1"> {data.name} </label></div>
                  ))}


              </div>
              <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 category.</div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Type</label>
                </div>
                <select class="form-select" aria-label="Default select example" id="jobType" name="jobType"  >
                  <option selected value="">Select</option>
                  {
                    jobTypes.map((data, index) => (
                      <option value={data.jobTypeId}>{data.name}</option>
                    ))}
                </select>
                <div id="jobtypeValidMsg" style={{ color: red }} className="error">Job Type is required.</div>
              </div>
            </div>



            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">TELL US WHAT YOU’RE LOOKING FOR</label>
                </div>
              </div>
              <div className="row px-3">
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="lookingFor"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setSeekingPosition(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSeekingPositionDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="seekingPositionValidMsg" style={{ color: red }} className="error">This field is required.</div>

                {/*
                               <textarea class="form-control textarea" maxlength="500" placeholder="Leave a comment here" id="lookingFor" spellcheck="false" onChange={e => setFieldName(e.target.value)} {...register("looking", {
                                    required: "This field is required.",
                                    maxLength: { value: 500, message: 'Should not allow more than 500 character' }
                                    })}></textarea>
                                 <ErrorMessage
                                    errors={errors}
                                    name="looking"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                /> 
                               */}
              </div>
            </div>



            <div className="col-lg-12 mb-10">
              <div className="mb-2">
                <div className="d-flex flex-column ">
                  <label className="required form-label">UPLOAD A RESUME</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <input class="form-control form-control-lg browse mr-2" id="resume" type="file" onChange={() => getImage()} />
                </div>
              </div>
              <small> 1MB Max, File Type: PDF,DOC</small>
            </div>
            <div id="fileError" style={{ color: red }} className="error">Invalid file format.</div>

            <div id="fileReqMsg" style={{ color: red }} className="error">Resume is required.</div>

            <button type="submit" className="btn btn-primary mt-5" style={{ maxWidth: "200px" }}> Register </button>
          </div>
          <div id="addjobseekersuccessMessage" class="alert alert-success" role="alert">Jobseeker Created Successfully</div>
          <div id="addjobseekerfailMessage" class="alert alert-danger" role="alert">Please try again</div>

        </div>

      </form>


    </>
  )
}
export { CreateJobseeker }